<template>
  <div class="#info">
    <van-nav-bar
      title="信息填写"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <h2 class="van-doc-demo-block__title">填写用户信息</h2>
    <van-form>
      <van-field readonly v-model="activity_name" label="活动名称" />
      <van-field
        v-model="dataForm.user_name"
        name="用户名"
        label="用户名"
        placeholder="用户名"
      />
      <van-field
        v-model="dataForm.phone"
        type="tel"
        maxlength="11"
        label="手机号"
        name="手机号"
        placeholder="手机号"
      />
      <van-field
        v-model="dataForm.pin"
        :disabled="dataForm.phone === ''"
        center
        type="number"
        maxlength="6"
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button v-if="send" size="small" type="warning" @click="sendMsg"
            >发送验证码</van-button
          >
          <van-button v-if="alreadysend" size="small" type="warning"
            >{{ second }}s后重新发送</van-button
          >
        </template>
      </van-field>

      <van-field
        readonly
        v-model="product_qrcode"
        right-icon="scan"
        name="产品编码"
        label="产品编码"
        placeholder="请点击右侧扫一扫按钮"
      >
        <template>
          <van-icon slot="right-icon" name="scan" @click="scan()"></van-icon>
        </template>
      </van-field>
      <van-divider>请对准产品机身二维码扫描</van-divider>
      <div style="margin: 16px">
        <van-button
          round
          block
          type="warning"
          native-type="submit"
          @click="onsubmit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      value: "",
      alreadysend: false,
      send: true,
      second: 60,
      product_qrcode: "", //加密产品码
      sms: "",
      activity_name: "",
      dataForm: {
        activity_id: 0,
        phone: "",
        product_qrcode: "",
        pin: "",
        user_name: "",
      },
      showPicker: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    //  修复iOS版微信HTML5 History兼容性问题
    if (to.path !== location.pathname) {
      //console.log("检测完成")
      // 此处不可使用location.replace
      location.assign(to.fullPath);
    } else {
      next();
    }
  },
  created() {
    if (localStorage.getItem("machinecode")) {
      this.ifqrcodeover(localStorage.getItem("machinecode"));
    }
    this.dataForm.activity_id = localStorage.getItem("activity_id");
    this.activity_name = localStorage.getItem("activity_name");
  },
  mounted() {
    this.getCofig();

    // this.ifqrcodeover()
  },
  methods: {
    // 发送验证码
    sendMsg: function () {
      if (this.dataForm.phone === "") {
        this.$toast("请先输入手机号");
        return;
      }
      return this.$http
        .post("/handler/activity/sms/SmsLogAdd.ashx", {
          mobile: this.dataForm.phone,
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$notify(res.msg);
          }
          this.alreadysend = true;
          this.send = false;
          this.timer();
          this.$toast("发送成功");
        })
        .catch(() => {});
    },
    // 验证码倒计时
    timer: function () {
      let promise = new Promise((resolve, reject) => {
        let setTimer = setInterval(() => {
          this.second -= 1;
          if (this.second <= 0) {
            this.second = 60;
            this.alreadysend = false;
            this.send = true;
            // resolve异步操作成功
            resolve(setTimer);
          }
        }, 1000);
      });
      // 将Promise对象的状态从“未完成”变为“成功”
      promise.then((setTimer) => {
        console.log("resolve异步操作成功");
        clearInterval(setTimer);
      });
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        path: "/activity-details",
        query: { id: localStorage.getItem("activity_id") },
      });
    },
    onsubmit() {
      if (
        this.dataForm.user_name === "" &&
        this.dataForm.user_name.length < 2
      ) {
        this.$toast("请输入正确的用户名");
        return;
      }
      if (this.dataForm.product_qrcode === "") {
        this.$toast("请获取产品编码");
        return;
      }
      return this.$http
        .post("/mobile/activity/ParticipantsRecordAdd.ashx", {
          data: JSON.stringify({
            activity_id: this.dataForm.activity_id,
            user_name: this.dataForm.user_name,
            phone: this.dataForm.phone,
            wx_id: localStorage.getItem("wxid"),
            product_qrcode: this.dataForm.product_qrcode,
            pin: this.dataForm.pin,
            ...this.$store.state,
          }),
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$notify(res.msg);
          }
          this.$toast("添加成功");
          this.$router.push({
            path: "/dashboard/activity",
          });
        })
        .catch(() => {});
    },
    //判断二维码是否过期
    ifqrcodeover(code) {
      return this.$http
        .post("/mobile/activity/QrCodeUsedCheck.ashx", { code: code })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.$dialog
              .alert({
                message: res.msg,
                theme: "round-button",
              })
              .then(() => {
                // on close
              });
          }
          if (res.data === false) {
            this.product_qrcode =
              code.substr(0, 2) +
              "*************" +
              code.substr(34, code.split("").length);
            this.dataForm.product_qrcode = code;
          } else if (res.data === true) {
            this.$dialog
              .alert({
                message: "该二维码已被使用，请换个码扫一扫",
                theme: "round-button",
              })
              .then(() => {
                // on close
              });
          }
        })
        .catch(() => {});
    },
    scan() {
      wx.scanQRCode({
        // 微信扫一扫接口
        desc: "scanQRCode desc",
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          let index = res.resultStr.lastIndexOf("?");
          console.log(res.resultStr.substring(index + 1, res.resultStr.length));
          this.ifqrcodeover(
            res.resultStr.substring(index + 1, res.resultStr.length)
          );
        },
        //  let getCode = res.resultStr // 当needResult 为 1 时，扫码返回的结果

        // console.log(res.resultStr);
      });
    },
    getCofig() {
      const that = this;
      let url = window.location.href;
      this.$http
        .post("/mobile/WxJsConfigGet.ashx", {
          url: url,
        })
        .then(function (res) {
          // console.log(res);
          if (res.data.MsgCode == "0") {
            //微信 的配置~~
            that.wxConfig(
              res.data.Data.appid,
              res.data.Data.timestamp,
              res.data.Data.nonceStr,
              res.data.Data.signature
            );
          } else {
            // that.$notify(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //wx.config的配置
    wxConfig(appId, timestamp, nonceStr, signature) {
      var self = this;
      wx.config({
        debug: false, // 开启调试模式,
        appId: appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        jsApiList: ["scanQRCode", "openLocation"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(() => {
        wx.getLocation({
          type: "gcj02",
          success: (res) => {
            console.log(res);
            // this.addressDetail(res.longitude, res.latitude);
            var latLng = new qq.maps.LatLng(res.latitude, res.longitude);
            getAddr.getAddress(latLng);
          },
          cancel: (res) => {
            this.$dialog
              .alert({
                message: "你拒绝了获取地理位置将无法参与该活动哦",
                theme: "round-button",
              })
              .then(() => {
                this.$router.push({
                  path: "/activity-details",
                  query: { id: localStorage.getItem("activity_id") },
                });
              });
          },
          fail: (res) => {
            this.$dialog
              .alert({
                message:
                  "检测到您未开启定位功能，请前往设置-授权应用管理允许微信定位",
                theme: "round-button",
              })
              .then(() => {
                this.$router.push({
                  path: "/activity-details",
                  query: { id: localStorage.getItem("activity_id") },
                });
              });
          },
        });
      });
      wx.error(function (res) {
        alert("出错了：" + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
        // this.$notify(res.errMsg)
      });
      var getAddr = new qq.maps.Geocoder({
        complete: function (res) {
          console.log(res);
          self.$store.state.lng = res.detail.location.lng;
          self.$store.state.lat = res.detail.location.lat;
          self.$store.state.province = res.detail.addressComponents.province;
          self.$store.state.city = res.detail.addressComponents.city;
          self.$store.state.addr = res.detail.address;
          self.getAreaList(
            res.detail.addressComponents.province,
            res.detail.addressComponents.city,
            res.detail.addressComponents.district
          );
          // _this.address = res.detail
          // var allAddress = res.detail.addressComponents
          // // _this.address = res.detail.nearPois
          // var address = res.detail.address
          // // alert('地址：' + JSON.stringify(_this.address))
          // console.log('地址：', address, allAddress.province, allAddress.city, allAddress.district)
          // alert('地址：' + address + allAddress.province + allAddress.city + allAddress.district)
        },
      });
    },
    addressDetail(lng, lat) {
      //获取地理位置
      var self = this;
      //全局的this在方法中不能使用，需要重新定义一下
      var getAddr = new qq.maps.Geocoder({
        complete: function (res) {
          console.log(res);
          self.$store.state.lng = res.detail.location.lng;
          self.$store.state.lat = res.detail.location.lat;
          self.$store.state.province = res.detail.addressComponents.province;
          self.$store.state.city = res.detail.addressComponents.city;
          self.$store.state.addr = res.detail.address;
          self.getAreaList(
            res.detail.addressComponents.province,
            res.detail.addressComponents.city,
            res.detail.addressComponents.district
          );
          // self.address = res.detail
          // var allAddress = res.detail.addressComponents
          // // _this.address = res.detail.nearPois
          // var address = res.detail.address
          // // alert('地址：' + JSON.stringify(_this.address))
          // console.log('地址：', address, allAddress.province, allAddress.city, allAddress.district)
          // alert('地址：' + address + allAddress.province + allAddress.city + allAddress.district)
        },
      });
    },
    // 区code
    getAreacodeList(id, quyu) {
      return this.$http
        .post("/mobile/area/AreaListGet.ashx", {
          level: 2,
          pageSize: 40,
          parentid: id,
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$notify(res.msg);
          }
          let code = res.data.JsonList.filter((val) => {
            return val.fullname === quyu;
          });
          this.$store.state.adcode = code[0].id;
        })
        .catch(() => {});
    },
    // 市code获取
    getCitycodeList(id, city, quyu) {
      return this.$http
        .post("/mobile/area/AreaListGet.ashx", {
          level: 1,
          pageSize: 40,
          parentid: id,
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$notify(res.msg);
          }
          let code = res.data.JsonList.filter((val) => {
            return val.fullname === city;
          });
          this.$store.state.city_code = code[0].id;
          this.getAreacodeList(code[0].id, quyu);
        })
        .catch(() => {});
    },
    // 区域列表获取
    getAreaList(provice, city, quyu) {
      return this.$http
        .post("/mobile/area/AreaListGet.ashx", { level: 0, pageSize: 40 })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$notify(res.msg);
          }
          let code = res.data.JsonList.filter((val) => {
            return val.fullname === provice;
          });
          this.$store.state.province_code = code[0].id;
          this.getCitycodeList(code[0].id, city, quyu);
        })
        .catch(() => {});
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
  },
};
</script>

<style lang="scss">
#info {
  background-color: #f5f5f5;
}
.van-doc-demo-block__title {
  margin: 0;
  padding: 20px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.van-nav-bar .van-icon {
  color: #ea5305;
}
.van-nav-bar__text {
  color: #ea5305;
}
</style>